<template>
    <div id="content">
        <router-link :to="$route.path.split('/').slice(0, -1).join('/')" class="back-link"><i class="bi bi-chevron-left"></i> {{ $t('plans.planModule.back') }}</router-link>
        <div class="admin-card edit-card">
            <div class="module-head">
                <div>
                    <div class="admin-section-label">
                        <i class="bi bi-diagram-2"></i>
                        {{ $t('plans.planModule.title') }}
                    </div>
                    <h1 class="module-name">{{ module.name }}</h1>
                </div>
                <div class="form-check form-switch m-0">
                    <input
                        v-model="module.status"
                        id="module-switch"
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        @change="switchModule(module.id)"
                    >
                    <label class="form-check-label" for="module-switch">{{ module.status ? $t('plans.planModule.on') : $t('plans.planModule.off') }}</label>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-row">
                    <label for="slug" class="form-label">{{ $t('plans.planModule.form.slug') }}</label>
                    <input type="text" class="form-control" readonly disabled :value="module.slug">
                </div>
                <template v-for="(f, index) in module.functions" :key="f.slug">
                    <div v-if="f.type === 'number'" class="form-row">
                        <label :for="f.slug" class="form-label">{{ f.name }}</label>
                        <input type="number" :id="f.slug" class="form-control" :name="f.slug" min="1"
                            v-model="module.functions[index].function_limit" required>
                    </div>
                    <div v-if="f.type === 'switch'" class="form-row">
                        <label :for="f.slug" class="form-label">{{ f.name }}</label>
                        <div class="form-check form-switch m-0">
                            <input class="form-check-input" type="checkbox" role="switch" :name="f.slug"
                                :id="f.slug" v-model="module.functions[index].function_limit">
                        </div>
                    </div>
                    <div v-if="f.slug === 'widgets'" class="form-row">
                        <label :for="f.slug" class="form-label">{{ f.name }}</label>
                        <input type="number" class="form-control" :id="f.slug" :placeholder="$t('plans.planModule.form.quantity')"
                            :name="f.slug + 'Number'" v-model="module.functions[index].function_limit">
                    </div>
                    <div v-if="f.slug === 'call_center'" class="form-row">
                        <label class="form-label">{{ $t('plans.planModule.form.callCenter') }}</label>
                        <div class="d-flex gap-2 align-items-center">
                            <div class="form-check form-switch m-0">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    name="mvoterCallCenterSwitch" id="callCenterSwitch" ref="call_center_switch"
                                    :checked="module.functions[index].function_limit !== 'null' ? true : false">
                            </div>
                            <input type="number" class="form-control" name="mvoterCallCenterPrice"
                                id="mvoterCallCenterPrice" :placeholder="$t('plans.planModule.form.pricePerMonth')"
                                v-model="module.functions[index].function_limit">
                        </div>
                    </div>
                </template>
            </div>

            <div class="form-actions">
                <button type="button" class="btn-purple" @click="submit">
                    <i class="bi bi-check2"></i>
                    <span>{{ $t('plans.planModule.save') }}</span>
                </button>
                <button type="button" class="btn-ghost" @click="$router.go(-1)">{{ $t('plans.planModule.cancel') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data:() => ({
        module: {},
        moduleId: '',
        moduleName: '',
        planId: ''
    }),
    async mounted() {
        this.$emit('setPageTitle', this.$t('plans.planModule.title'))

        this.planId = this.$route.params.id
        this.module = await this.getModuleBySlug()
        if(this.module) {
            this.moduleId = this.module.name.toLowerCase() + 'Switch'
            this.moduleName = this.onlyLetters(this.module.name).toLowerCase() + 'Switch'
        }
    },
    methods: {
        onlyLetters(str) {
            if (!str) return ''
            return str.replace(/[^a-zA-Zа-яА-Я]/g, '')
        },
        async getModuleBySlug() {
            let r = await this.$api.getModuleBySlug(this.planId, this.$route.params.slug)
            if(r.result === 'SUCCESS') {
                return r.data
            } else {
                this.$notify({
                    text: r.msg,
                    type: r.result.toLowerCase()
                })
                return false
            }
        },
        async submit() {
            this.module.functions.forEach(f => {
                if((f.type === 'number' || f.type === 'check-number') && isNaN(f.function_limit)) return false
            })
            let response = await this.$api.updatePlanModule(this.planId, this.module)

            if(response.result === 'SUCCESS') {
                this.$router.push(`/plans/${this.planId}/modules`)

                this.$notify({
                    text: this.$t('plans.planModule.updated'),
                    type: response.result.toLowerCase()
                })
            }
        },
        async switchModule(moduleId) {
            let response = await this.$api.switchModule(this.planId, moduleId)

            this.$notify({
                text: response.msg,
                type: response.result.toLowerCase()
            })
        }
    }
}
</script>

<style scoped>
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 14px;
    transition: color 0.15s ease;
}
.back-link:hover {
    color: #6d28d9;
}
.back-link i {
    font-size: 14px;
}

.edit-card {
    padding: 24px;
    max-width: 700px;
}

.module-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding-bottom: 18px;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 18px;
}

.module-name {
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
    letter-spacing: -0.01em;
}

.form-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-row {
    display: grid;
    grid-template-columns: 200px 1fr;
    align-items: center;
    gap: 16px;
}

.form-row .form-label {
    margin-bottom: 0;
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #e5e7eb;
    flex-wrap: wrap;
}
</style>
